export default __webpack_public_path__ + "static/media/profile.5020d4f9.jpg";